import axios from "axios";
import { createBrowserHistory } from "history";
import { API_BASE_URL } from "./config";

export const history = createBrowserHistory();

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only an expired / invalid token (401) should end the session. A 403 means
    // the user IS authenticated but not allowed for that specific resource —
    // logging them out on 403 wrongly kicks them to the login screen.
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      history.push("/");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default client;
